import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-dvh grid place-items-center bg-background">
                <div className="text-muted-foreground text-sm">Caricamento…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role))
        return <Navigate to="/" replace />;
    return children;
}
